"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQueryOperationPathZeroOrMore = void 0;
const actor_abstract_path_1 = require("@comunica/actor-abstract-path");
const context_entries_1 = require("@comunica/context-entries");
const utils_algebra_1 = require("@comunica/utils-algebra");
const utils_bindings_factory_1 = require("@comunica/utils-bindings-factory");
const asynciterator_1 = require("asynciterator");
/**
 * A comunica Path ZeroOrMore Query Operation Actor.
 */
class ActorQueryOperationPathZeroOrMore extends actor_abstract_path_1.ActorAbstractPath {
    mediatorMergeBindingsContext;
    constructor(args) {
        super(args, utils_algebra_1.Algebra.Types.ZERO_OR_MORE_PATH);
        this.mediatorMergeBindingsContext = args.mediatorMergeBindingsContext;
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const algebraFactory = new utils_algebra_1.AlgebraFactory(dataFactory);
        const bindingsFactory = await utils_bindings_factory_1.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
        const distinct = await this.isPathArbitraryLengthDistinct(algebraFactory, context, operation);
        if (distinct.operation) {
            return distinct.operation;
        }
        context = distinct.context;
        const predicate = operation.predicate;
        const sources = this.getPathSources(predicate);
        const sVar = operation.subject.termType === 'Variable';
        const oVar = operation.object.termType === 'Variable';
        if (operation.subject.termType === 'Variable' && operation.object.termType === 'Variable') {
            // Both subject and object are variables
            const results = await this.getNodes(operation, context, algebraFactory, sources);
            const subjectVar = operation.subject;
            const objectVar = operation.object;
            const termHashes = {};
            const bindingsStream = new asynciterator_1.MultiTransformIterator(results.bindingsStream, {
                multiTransform: (bindings) => {
                    const subject = bindings.get(subjectVar);
                    const graph = operation.graph.termType === 'Variable' ?
                        bindings.get(operation.graph) :
                        operation.graph;
                    return new asynciterator_1.TransformIterator(async () => {
                        // Set up an iterator to which getSubjectAndObjectBindingsPredicateStar will push solutions
                        const it = new asynciterator_1.BufferedIterator();
                        const counter = { count: 0 };
                        await this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subject, subject, predicate.path, graph, context, termHashes, {}, it, counter, algebraFactory, bindingsFactory);
                        return it.map((item) => {
                            // If the graph was a variable, fill in it's binding (we got it from the ?s ?p ?o binding)
                            if (operation.graph.termType === 'Variable') {
                                item = item.set(operation.graph, graph);
                            }
                            return item;
                        });
                    }, { autoStart: false, maxBufferSize: 128 });
                },
                autoStart: false,
            });
            const variables = (operation.graph.termType === 'Variable' ?
                [subjectVar, operation.object, operation.graph] :
                [subjectVar, operation.object])
                .map(variable => ({ variable, canBeUndef: false }));
            return {
                type: 'bindings',
                bindingsStream,
                metadata: async () => ({ ...await results.metadata(), variables }),
            };
        }
        if (!sVar && !oVar) {
            const variable = this.generateVariable(dataFactory);
            const starEval = await this.getObjectsPredicateStarEval(operation.subject, predicate.path, variable, operation.graph, context, true, algebraFactory, bindingsFactory);
            const bindingsStream = starEval.bindingsStream.map((item) => {
                if (operation.object.equals(item.get(variable))) {
                    return operation.graph.termType === 'Variable' ?
                        bindingsFactory.bindings([[operation.graph, item.get(operation.graph)]]) :
                        bindingsFactory.bindings();
                }
                return null;
            });
            return {
                type: 'bindings',
                bindingsStream,
                metadata: async () => ({
                    ...await starEval.metadata(),
                    variables: (operation.graph.termType === 'Variable' ? [operation.graph] : [])
                        .map(variable => ({ variable, canBeUndef: false })),
                }),
            };
        }
        // If (sVar || oVar)
        const subject = sVar ? operation.object : operation.subject;
        const value = (sVar ? operation.subject : operation.object);
        const pred = sVar ? algebraFactory.createInv(predicate.path) : predicate.path;
        const starEval = await this.getObjectsPredicateStarEval(subject, pred, value, operation.graph, context, true, algebraFactory, bindingsFactory);
        const variables = (operation.graph.termType === 'Variable' ? [value, operation.graph] : [value])
            .map(variable => ({ variable, canBeUndef: false }));
        return {
            type: 'bindings',
            bindingsStream: starEval.bindingsStream,
            metadata: async () => ({ ...await starEval.metadata(), variables }),
        };
    }
}
exports.ActorQueryOperationPathZeroOrMore = ActorQueryOperationPathZeroOrMore;
//# sourceMappingURL=ActorQueryOperationPathZeroOrMore.js.map